import React from 'react'

import { rangeTypes } from '@dataplace.ai/constants'
import { ReactComponent as LineIcon } from 'libs/shared/assets/src/lib/icons/rangeIcons/range.svg'
import { ReactComponent as WalkIcon } from 'libs/shared/assets/src/lib/icons/rangeIcons/onFoot.svg'
import { ReactComponent as CarIcon } from 'libs/shared/assets/src/lib/icons/rangeIcons/car.svg'
import { ReactComponent as BikeIcon } from 'libs/shared/assets/src/lib/icons/rangeIcons/bike.svg'

export const catchmentIconsMap = {
  [rangeTypes.line]: <LineIcon />,
  [rangeTypes.walk]: <WalkIcon />,
  [rangeTypes.bike]: <BikeIcon />,
  [rangeTypes.car]: <CarIcon />,
} as const

export const catchmentUnitsTranslationMap = {
  [rangeTypes.line]: 'general.meters_shortcut',
  [rangeTypes.walk]: 'general.minutes_shortcut',
  [rangeTypes.bike]: 'general.minutes_shortcut',
  [rangeTypes.car]: 'general.minutes_shortcut',
}

export const NO_OVERVIEW_DATA = 'no_overview_data'

export const OVERVIEW_COST = 4

